/**
 * Text Component Renderer
 *
 * Renders text content with markdown support and loading state handling.
 *
 * @since 6.9.0 Initial implementation
 */
import { html } from 'lit';
/**
 * Render text content using uo-markdown component
 *
 * @param {string | { loading?: boolean; [key: string]: unknown }} data - The text data to render
 * @param {ComponentProps} [props={}] - Additional props to spread
 *
 * @return {TemplateResult} The rendered text component
 */
export function textRenderer(data, props = {}) {
    // Handle both string data and object data with loading state
    const textContent = typeof data === 'string' ? data : data?.content || data?.text || '';
    const isLoading = props.loading || (typeof data === 'object' && data.loading);
    if (isLoading) {
        return html `
			<uo-placeholder 
				width="100px" 
				height="20px"
			></uo-placeholder>
		`;
    }
    return html `
		<uo-markdown 
			allowed-tags="strong,em,a"
			.content=${textContent || ''}>
		</uo-markdown>
	`;
}
